<template>
  <div>
    <main>
      <div class="uk-section uk-section-small">
        <div class="uk-flex uk-flex-center uk-flex-middle">
          <div class="uk-section-muted uk-section-small">
            <div class="uk-container">
              <form class="uk-form-stacked" @submit.prevent="sign_in">
                <legend class="uk-legend">Lab Report</legend>
                <div class="uk-margin">
                  <label class="uk-form-label uk-text-bold">ラボアカウント</label>
                  <div class="uk-inline">
                    <input type="text" class="uk-input uk-form-width-large" v-model="lab_account">
                  </div>
                </div>
                <button class="uk-button-primary uk-button-small uk-width-1-1" :disabled="!lab_account">Sign-in</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>

import constants from '../mixins/constants'

export default {
  name: 'SignIn',
  mixins: [constants],
  data: function() {
    return {
      lab_account: ''
    };
  },
  mounted() {
    if (localStorage.lab_account) {
      this.lab_account = localStorage.lab_account;
    }
  },
  methods: {
    sign_in: function() {
      localStorage.lab_account = this.lab_account;
      localStorage.course = this.COURSE;
      this.$router.push('/Home')
    }
  }
}
</script>
